<template>
  <div class="gvtronics">
    <hr>
    <div class="cont-one">
      <div class="shap-one"></div>
      <div class="row">
        <div class="col-md-4">
          <div class="disc">
            <div class="back">
              <div class="hbg"></div>
              <h3>GVTRONICS</h3>
            </div>

            <div class="linkss">
              <a href="#" class="gvt">GVTRONICS
                <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M19.7709 4.44699C19.7706 4.44676 19.7704 4.44648 19.7702 4.44625L15.688 0.383747C15.3821 0.0794115 14.8875 0.0805441 14.5831 0.386403C14.2787 0.692224 14.2799 1.18687 14.5857 1.49125L17.3265 4.21875H0.78125C0.349766 4.21875 0 4.56851 0 5C0 5.43148 0.349766 5.78125 0.78125 5.78125H17.3264L14.5857 8.50875C14.2799 8.81312 14.2788 9.30777 14.5831 9.61359C14.8875 9.91949 15.3822 9.92054 15.688 9.61625L19.7702 5.55375C19.7704 5.55351 19.7706 5.55324 19.7709 5.55301C20.0769 5.24761 20.0759 4.75136 19.7709 4.44699Z"
                      fill="white"/>
                </svg>
              </a>
              <a href="#" class="non">
                <img src="@/assets/store/img/non.png" width="29px" height="29px" alt="non logo">find us on noon
              </a>
            </div>
          </div>

        </div>
        <div class="col-md-8">
          <div class="slide-cont">
            <div class="owl-carousel owl-carousel2 owl-theme">
              <div class="cont">
                <img src="@/assets/store/img/gvslide1.png">
              </div>
              <div class="cont">
                <img src="@/assets/store/img/gvslide1.png">
              </div>
              <div class="cont">
                <img src="@/assets/store/img/gvslide1.png">
              </div>
              <div class="cont">
                <img src="@/assets/store/img/gvslide1.png">
              </div>
            </div>
            <div class="store-items" style="z-index: 1; display: flex; align-items: center;">
              <div @click.prevent="prev(1)" class="owl-prev" style="margin-right: 5rem; cursor: pointer;">
                <img src="@/assets/store/img/larrow.png">
              </div>
              <div class="store-item-img" v-for="(section, index) in firstSection.slice(startFirstSection, startFirstSection + 4)" :key="index">
                <img class="w-100" :src="getImgUrl(section)" alt="">
              </div>
              <div @click.prevent="next(1)" class="owl-next" style="margin-left: 5rem; cursor: pointer;">
                <img src="@/assets/store/img/rarrow.png">
              </div>
            </div>
            <a style="top: 140px;" href="#" class="more">See more</a>
          </div>

        </div>
      </div>
    </div>
    <div class="cont-two">
      <div class="shap-two"></div>
      <div class="row">
        <div class="col-md-8">
          <div class="slide-cont">
            <div class="owl-carousel owl-carousel3 owl-theme">
              <div class="cont">
                <img src="@/assets/store/img/cvlearnslide.png">
              </div>
              <div class="cont">
                <img src="@/assets/store/img/cvlearnslide.png">
              </div>
              <div class="cont">
                <img src="@/assets/store/img/cvlearnslide.png">
              </div>
              <div class="cont">
                <img src="@/assets/store/img/cvlearnslide.png">
              </div>
            </div>
            <div class="store-items" style="z-index: 1; display: flex; align-items: center;">
              <div @click.prevent="prev(2)" class="owl-prev" style="margin-right: 5rem; cursor: pointer;">
                <img src="@/assets/store/img/larrow.png">
              </div>
              <div class="store-item-img" v-for="(section, index) in secondSection.slice(startSecondSection, startSecondSection + 4)" :key="index">
                <img class="w-100" :src="getImgUrl(section)" alt="">
              </div>
              <div @click.prevent="next(2)" class="owl-next" style="margin-left: 5rem; cursor: pointer;">
                <img src="@/assets/store/img/rarrow.png">
              </div>
            </div>
            <a style="top: 140px;" href="#" class="more">See more</a>
          </div>

        </div>
        <div class="col-md-4">
          <div class="disc">
            <div class="back">
              <div class="hbg"></div>
              <h3>GVMUSIC</h3>
            </div>
            <div class="linkss">
              <a href="#" class="gvt">GVMUSIC
                <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M19.7709 4.44699C19.7706 4.44676 19.7704 4.44648 19.7702 4.44625L15.688 0.383747C15.3821 0.0794115 14.8875 0.0805441 14.5831 0.386403C14.2787 0.692224 14.2799 1.18687 14.5857 1.49125L17.3265 4.21875H0.78125C0.349766 4.21875 0 4.56851 0 5C0 5.43148 0.349766 5.78125 0.78125 5.78125H17.3264L14.5857 8.50875C14.2799 8.81312 14.2788 9.30777 14.5831 9.61359C14.8875 9.91949 15.3822 9.92054 15.688 9.61625L19.7702 5.55375C19.7704 5.55351 19.7706 5.55324 19.7709 5.55301C20.0769 5.24761 20.0759 4.75136 19.7709 4.44699Z"
                      fill="white"/>
                </svg>
              </a>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import $ from "jquery";
import 'owl.carousel';

export default {
  mounted() {
    window.fn = require('owl.carousel');
    $('.owl-carousel2').owlCarousel({
      loop: true,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      responsiveClass: true,
      dots: false,
      navSpeed: 700,
      navText: [`<img src="${require('@/assets/store/img/larrow.png')}"> `, `<img src="${require('@/assets/store/img/rarrow.png')}"> `],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 1
        },
        740: {
          items: 1
        },
        940: {
          items: 1
        }
      },
      nav: false
    })
    $('.owl-carousel3').owlCarousel({
      loop: true,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: false,
      navSpeed: 700,
      responsiveClass: true,
      navText: [`<img src="${require('@/assets/store/img/larrow.png')}"> `, `<img src="${require('@/assets/store/img/rarrow.png')}"> `],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 1
        },
        740: {
          items: 1
        },
        940: {
          items: 1
        },
      },
      nav: false
    })
  },
  data() {
    return {
      startFirstSection: 0,
      startSecondSection: 0,
      firstSection: [
        'A.png',
        'B.png',
        'C.png',
        'D.png',
        'A.png',
      ],
      secondSection: [
        'mind1.png',
        'mind2.png',
        'mind3.png',
        'mind4.png',
        'mind1.png',
      ],
    }
  },
  methods: {
    getImgUrl: function (img) {
      return require('@/assets/store/img/' + img);
    },
    prev(section) {
      if (section === 1) {
        if (this.startFirstSection !== 0) {
          this.startFirstSection--;
        }
      } else {
        if (this.startSecondSection !== 0) {
          this.startSecondSection--;
        }
      }
    },
    next(section) {
      if (section === 1) {
        if (this.firstSection.length > (this.startFirstSection + 4)) {
          this.startFirstSection++;
        }
      } else {
        if (this.secondSection.length > (this.startSecondSection + 4)) {
          this.startSecondSection++;
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/store/styles.scss";

$maincolor: #1D1D1D;


.gvtronics {
  background: $maincolor;
  overflow: hidden;

  hr {
    height: 6px;
    background: #DA0A2C;
    transform: matrix(1, 0, 0, -1, 0, 0);
    opacity: 1;
    margin: 0;
    @media (min-width: $width1) and (max-width: $width2) {
      height: 3px;
    }
  }

  .cont-one {
    margin-bottom: 174px;
    position: relative;

    .shap-one {
      position: absolute;
      width: 800px;
      height: 800px;
      left: -93px;
      top: 0;
      background: radial-gradient(38.86% 38.86% at 50% 50%, #DA0A2C 0%, rgba(29, 29, 29, 0) 100%);
      @media (min-width: $width1) and (max-width: $width2) {
        width: 360px;
        height: 107px;
        left: 16px;

      }
    }

    .disc {
      position: relative;
      width: 145%;
      top: 42%;
      z-index: 99;
      text-align: center;
      @media (min-width: $width1) and (max-width: $width2) {
        width: 100%;
        top: 17%;
        margin-bottom: 54px;
      }

      .back {
        width: 100%;
        height: auto;
        margin: 0 auto;
        background-color: transparent;
        text-align: center;
        @media (min-width: $width1) and (max-width: $width2) {
          width: 76%;
          height: 60px;
        }

        .hbg {
          width: 100%;
          height: 125px;
          background-image: url('~@/assets/store/img/GVTRONICSh.png');
          background-size: contain;
          background-repeat: no-repeat;
        }

        h3 {
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 69px;
          line-height: 69px;
          text-align: justify;
          color: #FFFFFF;
          position: absolute;
          top: 47px;
          left: 169px;
          @media (min-width: $width1) and (max-width: $width2) {
            font-size: 28px;
            top: -4px;
            left: 119px;
          }
        }
      }

      .linkss {
        margin-top: 16px;

        .gvt {
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 98.3%;
          color: #FFFFFF;
          padding: 10px 20px;
          background: unset;
          border: 10px solid;
          border-image-slice: 1;
          border-width: 1px;
          border-image-source: linear-gradient(to right, #FFF, #911327);
          text-decoration: none;
          @media (min-width: $width1) and (max-width: $width2) {
            border-image-source: linear-gradient(to right, #FFF, #1d1d1d);
          }

          svg {
            margin-left: 20px
          }
        }

        .non {
          @extend .gvt;
          border-image-source: none;
          border: none;
          font-size: 13px;

          img {
            margin-right: 10px;
          }


        }
      }


    }

    .slide-cont {
      width: 100%;
      position: relative;
      left: 0;
      text-align: center;

      .more {
        border: 2px solid #FFFFFF;
        box-sizing: border-box;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
        padding: 4px 22px;
        text-decoration: none;
        position: relative;
        top: 126px;
        right: 8%;
        @media (min-width: $width1) and (max-width: $width2) {
          font-size: 14px;
          border: 1px solid #FFFFFF;
          padding: 5px 15px;
          top: 58px;
          right: unset;

        }

      }


    }
  }

  .cont-two {
    @extend .cont-one;
    position: relative;

    .shap-two {
      position: absolute;
      width: 800px;
      height: 800px;
      right: -100px;
      top: 0px;
      background: radial-gradient(38.86% 38.86% at 50% 50%, #DA0A2C 0%, rgba(29, 29, 29, 0) 100%);
      border-radius: 50%;
      @media (min-width: $width1) and (max-width: $width2) {
        width: 360px;
        height: 107px;
        left: 16px;
        top: -18px;

      }
    }

    .row {
      @media (min-width: $width1) and (max-width: $width2) {
        flex-direction: column-reverse;

      }

      .disc {
        left: -187px;
        width: 111%;
        @media (min-width: $width1) and (max-width: $width2) {
          left: 0;
          width: 100%;

        }

        .back {
          .hbg {
            width: 100%;
            height: 125px;
            background-image: url('~@/assets/store/img/GVm-bg.png');
            background-size: contain;
            background-repeat: no-repeat;
          }

          h3 {
            top: 46px;
            left: 182px;

            @media (min-width: $width1) and (max-width: $width2) {
              top: 6px;
              left: 129px;

            }
          }
        }

        .linkss {
          margin-left: 180px;
          @media (min-width: $width1) and (max-width: $width2) {
            margin-left: unset;

          }

          .gvt {
            background: linear-gradient(90deg, #DA0A2C 0%, #DA0A2C 222.91%);
            border: none;
            @media (min-width: $width1) and (max-width: $width2) {
              background: unset;
              border: 10px solid;
              border-image-slice: 1;
              border-width: 1px;
              border-image-source: linear-gradient(to right, #FFF, #1d1d1d);
            }
          }
        }

        .more {
          right: unset;
          left: 8%;

        }


      }
    }
  }
}

.store-items {
  position: absolute;
  left: 25px;
  bottom: -112px;
  @media (min-width: $width1) and (max-width: $width2) {
    left: unset;
    right: 39px;
    display: flex;
    width: 80%;
    overflow: hidden;
    margin: 0 auto;
    bottom: -48px;
  }

  .store-item-img {
    width: 210px;
    height: 210px;
    margin: 5px 7px;
    @media (min-width: $width1) and (max-width: $width2) {
      width: 90px;
      height: 90px;
    }
  }
}
</style>
